import React from "react";

export const Content: React.FC = ({ children, className }) => {
  let classes = `${className} px-7.5 sm:px-12 lg:px-28 xl:px-28 2xl:px-28 mx-auto dark:text-text-dm w-full ${!className?.includes('max-w') ? 'max-w-1920' : ''}`
  return (
    <div className={classes}>
      {children}
    </div>
  );
};

